import "../../styles/OnboardingScreen3.css";
import screen3Img from "../../assets/onboarding/screen3.png";

export default function OnboardingScreen3() {
  return (
    <div className="ob3">
      <div className="ob3Text">
        <h1>
          Обирай так,
          <br />
          як зручно тобі
        </h1>

        <p>
          Спілкуйся з чатом або переходь
          <br />
          у каталог, переглядай товари,
          <br />
          порівнюй і додавай у кошик.
        </p>

        <p className="ob3Highlight">
          Усе як у звичному
          
          e-commerce,
         
          тільки<br /> <span>швидше та персональніше.</span>
          
          
        </p>
      </div>

      <div className="ob3ImageWrap">
        <img src={screen3Img} alt="Catalog and cart" />
      </div>
    </div>
  );
}